<template>
  <div>
    <div class="bg">
      <div class="box">
        <div class="router_box">
          <div class="left">
            <img src="../../assets/stylus/image/logo_2.png" />
            <div class="router_home" @click="to_router('edit_home')">
              首页
            </div>
          </div>
          <div class="right">
            <div class="right_but" @click="start_writing">
              开始创作
            </div>
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img src="../../assets/stylus/image/head.png" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="我的项目">我的项目</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div class="bottom_div">
        <h2>
          <span style="font-weight:bolder;">|</span>{{ router_item.WorkName }}
          <el-tag size="mini">标签</el-tag>
        </h2>
        <p>
          作者：
          <span style="color:#000;">
            {{ $route.query.User.Nickname }}
          </span>
        </p>
        <p>
          日期：<span style="color:#000;">
            {{ filters.vdateAdd($route.query.CreatedAt) }}
          </span>
        </p>
        <div class="bo_box" :style="{ height: clientHeight + 'px' }">
          <div class="left">
            <iframe :src="src_id" scrolling="no"> </iframe>
          </div>
          <div class="right">
            <div class="right_box">
              <p>作品简介</p>
              <span>我是作品简介</span>
            </div>

            <div class="right_box">
              <p>操作说明</p>
              <span>我是操作说明</span>
            </div>

            <div class="right_box">
              <p>标签</p>
              <el-tag size="mini">游戏</el-tag>
            </div>
          </div>
        </div>

        <div class="bottom_box">
          <el-popover placement="top-start" trigger="hover">
            <vue-qr :text="url" :size="100"></vue-qr>
            <div class="p" slot="reference">
              <i
                class="el-icon-mobile-phone
"
              ></i
              >用手机玩
            </div>
          </el-popover>

          <el-popover
            placement="top-start"
            trigger="hover"
            style="margin-left:30px;"
          >
            <vue-qr :text="url" :size="100"></vue-qr>
            <div class="p" slot="reference">
              分享
              <i
                style="color:#02c506;"
                class="el-icon-chat-round
"
              ></i>
            </div>
          </el-popover>
        </div>
      </div>

      <div class="b_box">
        <div class="lef">
          <h3>留言</h3>
          <el-input
            v-model="leaving"
            placeholder="请输入留言内容"
            type="textarea"
            :rows="4"
          ></el-input>

          <el-button size="mini" type="primary">提交</el-button>
        </div>

        <div class="rig">
          <h3>猜你喜欢</h3>

          <ul>
            <li v-for="(item, i) in scratch_list" :key="i">
              <img style="width:120px;" :src="item.Image" />
              <div class="right">
                {{ item.WorkName }}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 页脚 -->
      <fotter></fotter>
    </div>
  </div>
</template>

<script>
import { post_image_url_api } from "@/api/resources.js";
import { mapGetters } from "vuex";
import { get_community_api, getScratch } from "@/api/scratch.js";
import fotter from "../components/fotter.vue";
import vueQr from "vue-qr";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    fotter,
    vueQr,
  },
  data() {
    return {
      scratch_list: [],
      router_item: {},
      src_id: "",
      clientHeight: 0,
      leaving: "", //留言
      url: "",
      options_user: [],
    };
  },

  created() {
    this.clientHeight =
      document.documentElement.clientHeight - 200 ||
      document.body.clientHeight - 400;
    this.router_item = this.$route.query;
    this.src_id = "/scratch/?stageArea=true&id=" + this.$route.query.Id;

    const loading = this.$loading({
      lock: true,
      text: "项目较大，如没有出现，请耐心等待一会儿",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    setTimeout(() => {
      loading.close();
    }, 1500);

    get_community_api("", 0, 5).then((res) => {
      let v = res.data.Results;
      v.forEach((vs, i) => {
        post_image_url_api([vs.ImageId]).then((value) => {
          console.log(value);
          vs.Image = "https://" + value.data[0];
          if (v.length == i + 1) {
            this.scratch_list = v;
            console.log(this.scratch_list);
          }
        });
      });
    });

    getScratch(this.$route.query.Id).then((res) => {
      post_image_url_api([res.data.WorkId]).then((val) => {
        this.url =
          "https://www.cgyounger.com/app_sc?value=" +
          val.data[0] +
          "&title=" +
          this.$route.query.WorkName +
          "&name=" +
          this.$route.query.User.Nickname;
      });
    });
  },

  methods: {
    handleCommand(item) {
      if (item == "我的项目") {
        this.$router.push({ path: "/my_works" });
      }
    },

    //跳转到首页
    to_router(url) {
      this.$router.push({ path: url });
    },

    //开始创作
    start_writing() {
      var url = "/scratch/?stageArea=false";
      window.open(url);
    },
  },
};
</script>

<style lang="stylus" scoped>
.bg {
  width:100%;
  height:60px;
  background:#ffb000;

  .box {
     width:86%;
     padding:8px 0;
     margin:0 auto;
     .router_box {
       width:100%;
       display:flex;
       justify-content:space-between;
       .left {
          width:26%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width:130px;
            margin-right:30px;
          }
          .router_home {
              color: white;
              font-size:14px;
              cursor: pointer;
          }
          .router_home:hover {
              color:#f3f3f3;
          }
       }

       .right {
          display: flex;
          align-items:center;
          .right_but {
            background:#fff;
            padding: 6px 10px;
            border-radius: 4px;
            color: #333;
            margin-right:20px;
            cursor: pointer;
          }
          .right_but:hover {
            background:rgba(255,255,255,0.9);
            color:#000;
          }
          img {
            width:30px;
          }
       }
     }
  }
  .bottom_div {
     width:86%;
     margin:30px auto;
     border-radius:6px;
     box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
     padding:20px;
     background:#fff;
     h2 {
       color:#333;
       font-size:18px;
       span {
         color:#409EFF;
         margin-right:8px;
       }
     }
     p {
         color:#888;
         margin-top:12px;
     }
     .bo_box {
        width:100%;
        margin-top:20px;
        border:1px solid #ccc;
        display: flex;
        justify-content:space-between;
        .left {
          width:80%;
          overflow:hidden;
          iframe {
          width:100%;
          height:100%;
        }

        }
        .right {
          width:20%;
          padding-left:20px;
          background:#e8edf1;
          border-left:1px solid #eee;
          // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)

          .right_box {
            margin-top:20px;
            margin-bottom:50px;
            p {
              font-size:16px;
              color:#000;
              margin-bottom:12px;
            }

            span {
              color:#777;
            }

            .el-tag {
              background:#409EFF;
              color:#dbedff;
            }

          }
        }
     }
  }
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .bottom_box {
    height:40px;
    border-top:1px solid #eee;
    margin-top:30px;
    img {
      border: 1px solid #eee;
    }
    .p {
      font-size: 14px;
      cursor: pointer;
      display: inline;
      line-height: 60px;
      color:#888;
    }
  }
  .b_box {
     width:86%;
     margin:30px auto;
     border-radius:6px;
     box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
     padding:20px;
     background:#fff;
     display:flex;

     .lef {
       width:70%;
       padding-right:40px;
      h3 {
       font-size:16px;
       margin-bottom:20px
     }
     .el-input {
       margin-top:20px;
     }
     .el-button{
       margin-top:30px;
       position: relative;
       right:0;
     }
     }

     .rig {
       padding-left:40px;
       width:30%;
       h3 {
         font-size:18px;
         padding-bottom:20px;
         width:100%;
       }
       li {
         width:100%;
         height:80px;
         margin-bottom:30px;
         overflow: hidden;
           img {
             width:60%;
             border-radius:4px;
             float:left;
             background:#eee;
           }
         .right{
           float:left;
           margin-left:12px;
           font-size:14px;
           overflow: hidden;
           text-overflow: ellipsis;
           white-space: nowrap;
           width:50%;
         }
       }
     }

  }
</style>
